import { css, Label, styled } from 'canoe';
import React from 'react';

import { Axes } from 'craft/components/Resize/types';
import { Size, SizeType, SizeValue } from 'craft/components/Size';
import { percent, px } from 'craft/components/Size/sizeValues';

export interface DraggingLabelProps {
  height: number;
  width: number;
  latestSize: Size;
  originalSize: Size;
  isMappedOverSource: boolean;
  axis?: Axes;
}

const Container = styled.div<Pick<DraggingLabelProps, 'height' | 'width'>>`
  ${({ height, width }) => css`
    position: absolute;
    z-index: 10;
    text-align: right;
    top: ${height - 30}px;
    left: ${width - 154}px;
    width: 150px;
    display: flex;
    justify-content: end;
  `}
`;

const SizeWrapper = styled.div<{ isMappedOverSource: boolean }>`
  ${({ theme, isMappedOverSource }) => css`
    background-color: ${isMappedOverSource
      ? theme.colors.MangoOrangeD10
      : theme.colors.BrandPurple};
    border-radius: ${theme.borderRadius.regular};
    padding: 0 ${theme.spaces.xs};

    & > label {
      color: ${theme.colors.White};
    }
  `}
`;

const writeLabel = (type: SizeType, size: SizeValue) => {
  if (!size || size === SizeType.Default || type === SizeType.Auto || type === SizeType.Default) {
    return SizeType.Default;
  }
  if (type === SizeType.Pixel) {
    return px(size);
  }
  return percent(size);
};

export const DraggingLabel = ({
  height,
  width,
  latestSize,
  originalSize,
  isMappedOverSource,
  axis,
}: DraggingLabelProps) => {
  const widthSize = axis !== Axes.Y ? latestSize.width : originalSize.width;
  const heightSize = axis !== Axes.X ? latestSize.height : originalSize.height;

  return (
    <Container height={height} width={width}>
      <SizeWrapper isMappedOverSource={isMappedOverSource}>
        <Label color="white">
          {writeLabel(widthSize.type, widthSize.value)}&nbsp;x&nbsp;
          {heightSize.type === SizeType.Percentage
            ? 'auto'
            : writeLabel(heightSize.type, heightSize.value)}
        </Label>
      </SizeWrapper>
    </Container>
  );
};
